import { render, staticRenderFns } from "./rightList.vue?vue&type=template&id=1f782475&scoped=true&"
import script from "./rightList.vue?vue&type=script&lang=js&"
export * from "./rightList.vue?vue&type=script&lang=js&"
import style0 from "./rightList.vue?vue&type=style&index=0&id=1f782475&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f782475",
  null
  
)

export default component.exports